import './TimePicker.scss';
import classNames from 'classnames';
import React, { useEffect, useRef, useState } from 'react';
import Dropdown from '../../base/Dropdown/Dropdown';
import TextInput from '../TextInput/TextInput';
import { addZero, getMomentValue } from '../../../utils/utils';

export default function TimePicker(props) {
  const {
    controlId = '',
    className = '',
    hideSeconds = false,
    disabled = false,
    withLabel = true,
    inputProps = {},
  } = props;
  const {
    value = '',
    onChange = () => {},
    name = '',
  } = inputProps;
  const format = `HH:mm${!hideSeconds ? ':ss' : ''}`;
  const anchorElement = useRef(null);
  const hourRef = useRef(null);
  const minRef = useRef(null);
  const secRef = useRef(null);
  const [momentValue, setMomentValue] = useState(getMomentValue(value, format));
  useEffect(() => {
    const mv = getMomentValue(value, format);
    setMomentValue(mv);
    if (!value) {
      onSelect(mv.format(format));
    }
  }, [value]);

  const onToggleOpen = isOpen => {
    if (isOpen && hourRef.current) {
      scrollToSelectedElement(hourRef.current);
    }
    if (isOpen && minRef.current) {
      scrollToSelectedElement(minRef.current);
    }
    if (isOpen && secRef.current) {
      scrollToSelectedElement(secRef.current);
    }
  };

  const scrollToSelectedElement = ref => {
    const selectedElements = ref.getElementsByClassName('selected');
    if (!selectedElements || !selectedElements[0]) {
      return;
    }
    const selected = selectedElements[0];
    ref.scrollTo(0, selected.offsetTop);
  };

  const onSelect = value => {
    onChange({ target: { value, name } });
  };

  const handleSelectHour = v => () => {
    onSelect(momentValue.clone().set('hour', v).format(format));
  };

  const handleSelectMinute = v => () => {
    onSelect(momentValue.clone().set('minute', v).format(format));
  };

  const handleSelectSecond = v => () => {
    onSelect(momentValue.clone().set('second', v).format(format));
  };

  const isSelectHour = hour => momentValue.get('hours') === hour;

  const isSelectMinute = min => momentValue.get('minutes') === min;

  const isSelectSecond = sec => momentValue.get('seconds') === sec;

  return (
    <div
      className={classNames('time-picker', className)}
      // Это не криптография! Если ваш анализатор этого не понимает не используйте этот анализатор
      // nosemgrep
      id={controlId || `time-picker-${Math.random()}`}
    >
      <Dropdown
        usePortal
        onToggleOpen={onToggleOpen}
        disabled={disabled}
      >
        <Dropdown.Toggle className="mini-profile-button">
          <TextInput
            {...props}
            // readOnly
            inputProps={{
              value: momentValue.format(format),
              onChange: () => {
              },
            }}
            containerRef={anchorElement}
            {...inputProps}
            withLabel={withLabel}
            disabled={disabled}
          />
        </Dropdown.Toggle>
        <Dropdown.Menu className="time-picker-wrapper" anchorElement={anchorElement}>
          <div className="time-blocks">
            {renderTimeBlock(24, handleSelectHour, isSelectHour, hourRef)}
            {renderTimeBlock(60, handleSelectMinute, isSelectMinute, minRef)}
            {!hideSeconds ? renderTimeBlock(60, handleSelectSecond, isSelectSecond, secRef) : null}
          </div>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
}

export const renderTimeItem = (value, onClick = () => {}, isSelected = () => {}) => (
  <div
    key={value}
    className={classNames('time-item', { selected: isSelected(value) })}
    onClick={onClick(value)}
  >
    {addZero(2, value)}
  </div>
);

export const renderTimeBlock = (count = 0, onClick = () => {}, isSelected = () => {}, ref = null) => (
  <div className="time-block custom-scroll-theme" ref={ref}>
    {/* eslint-disable-next-line no-unused-vars */}
    {[...Array(count)].map((e, i) => (renderTimeItem(i, onClick, isSelected)))}
  </div>
);
